import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      - Hodiaŭ alkalo, morgaŭ acido… 
      Tiel la vivo fluas…
    </p>
    
    <p class="mb-3">
      - Sed vi mem, kiel vi mem rilatas al la kemia reakcio?
    </p>
    
    <p class="mb-3">
      - Fakte, neniel. 
      Mi simple ŝanĝas la koloron.
    </p>
    `
  )
}

const itemName = {
  esp: 'La lakmuso'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;